import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanText',
  standalone: true,
})
export class CleanTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.replace(/\u00A0|&nbsp;/g, ' ');
  }
}
